module.exports = __webpack_public_path__ + "static/img/completefood_conejos.c282351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/completefood_conejos.jpg
// module id = ArK4
// module chunks = 0